import { render, staticRenderFns } from "./InAnswer.vue?vue&type=template&id=12d3299f&"
import script from "./InAnswer.vue?vue&type=script&lang=js&"
export * from "./InAnswer.vue?vue&type=script&lang=js&"
import style0 from "./InAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports